/**
 * @generated SignedSource<<0a2189aed9957af99389233fcd569ccc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PLUProductItemBody_PLUProduct$data = {
  readonly active: boolean;
  readonly category: {
    readonly " $fragmentSpreads": FragmentRefs<"PLUProductItemCategoryTag_PLUCategory">;
  };
  readonly id: string;
  readonly image: {
    readonly id: string;
    readonly sizes: ReadonlyArray<{
      readonly width: number;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"Image_image">;
  } | null;
  readonly imageUrl: string | null;
  readonly title: string;
  readonly " $fragmentType": "PLUProductItemBody_PLUProduct";
};
export type PLUProductItemBody_PLUProduct$key = {
  readonly " $data"?: PLUProductItemBody_PLUProduct$data;
  readonly " $fragmentSpreads": FragmentRefs<"PLUProductItemBody_PLUProduct">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PLUProductItemBody_PLUProduct",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PLUCategory",
      "kind": "LinkedField",
      "name": "category",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PLUProductItemCategoryTag_PLUCategory"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageSize",
          "kind": "LinkedField",
          "name": "sizes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Image_image"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PLUProduct",
  "abstractKey": null
};
})();

(node as any).hash = "b21225688a496f714e70797153f673de";

export default node;
